"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    LogoBanner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: function background(_ref) {
        var props = _ref.props;
        return props.background;
      },
      cursor: function cursor(_ref2) {
        var props = _ref2.props;
        return props.cursor;
      },
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      aspectRatio: '2/1'
    },
    Text: {
      fontFamily: theme['$font-default'],
      fontSize: 25,
      fontWeight: 500,
      color: '#fff',
      lineHeight: 'initial',
      display: 'block',
      margin: [0, 10],
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      userSelect: 'none'
    },
    Image: {
      objectFit: 'cover',
      objectPosition: 'center',
      aspectRatio: '2/1',
      width: '100%'
    },
    Gradient: {
      background: 'linear-gradient(to bottom, rgba(64, 68, 68, 0.16), rgba(255, 255, 255, 0.01))',
      position: 'absolute',
      width: '100%',
      height: '100%'
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map